import { MonthlyProductTarget, MonthlyProductVolume } from 'types/product.ts'

export enum TagTypes {
  MONTHLY_PRODUCTS_TARGETS = 'monthlyProductsTargets',
  MONTHLY_PRODUCTS_VOLUMES = 'monthlyProductsVolumes'
}

// REQUEST & RESPONSE TYPES

export type GetMonthlyProductsTargetsResponse = {
  monthlyTargets: MonthlyProductTarget[]
}

export type GetMonthlyProductsVolumesResponse = {
  monthlyVolumes: MonthlyProductVolume[]
}
